import { render, staticRenderFns } from "./PushNotifications.vue?vue&type=template&id=508b6dec&scoped=true"
import script from "./PushNotifications.vue?vue&type=script&lang=js"
export * from "./PushNotifications.vue?vue&type=script&lang=js"
import style0 from "./PushNotifications.vue?vue&type=style&index=0&id=508b6dec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508b6dec",
  null
  
)

export default component.exports